module.exports = __webpack_public_path__ + "img/user_photo.36c99467.png";